/***
 * @Authors:
 *      Rahul
 ***/

/*** Imports ***/

/* Library imports */

/* Component imports */

/* Style imports */

import { getFacebookAppIdId, getGoogleClientId } from "./UtilityLg";
import Config from "./Config";

/*** End Imports ***/

const ConstantsLg = {
    BUILD: {
        DEVELOPMENT: 1,
        STAGING: 2,
        PREPROD: 3,
        PRODUCTION: 4
    },
    // FACEBOOK_APP_ID: Config.API_KEY.FACEBOOK_APP_ID,
    GOOGLE_CLIENT_ID: Config.API_KEY.GOOGLE_CLIENT_ID,
    // TEMPORARY FIX: Added default value for GOOGLE_CLIENT_ID to prevent runtime errors
    // TODO: Remove this temporary fix before production build
    //GOOGLE_CLIENT_ID: (Config.API_KEY && Config.API_KEY.GOOGLE_CLIENT_ID) || "temporary-google-client-id",
    URL: {
        GREEN_TICK: "https://storage.googleapis.com/ck-prod/ck_app_assets/Group%402x.png",
    },
    ICONS: {
        CROSS_ICON: "https://storage.googleapis.com/ck-prod/ck_app_assets/ck-cross-icon-white.svg",
        GOOGLE_ICON_RED: "https://storage.googleapis.com/ck-prod/ck_app_assets/ck-google-icon-red.svg",
        FACEBOOK_ICON_BLUE: "https://storage.googleapis.com/ck-prod/ck_app_assets/ck-facebook-icon-blue.svg",
        SHOW_PASSWORD_BLUE: "https://storage.googleapis.com/ck-prod/ck_app_assets/ck-show-password-icon-blue.svg",
        EDIT_ICON_BLUE: "https://storage.googleapis.com/ck-prod/ck_app_assets/ck-edit-icon-blue.png"
    },
    ROUTE: {
        REC_LOGIN: "/login-recruiter",
        PROF_LOGIN_BY_EMAIL: "/login-professional-by-email",
        FREELANCER_LOGIN: "/login-freelancer",
        FRONTEND_ERROR_NOTIFICATION: '/frontenderrornotification'
    },

    LOGIN_TYPE: {
        PROFESSIONAL: 1,
        RECRUITER: 2,
        PROFESSIONAL_MOBILE: 3,
        PROFESSIONAL_EMAIL_DESKTOP: 4,
        PROFESSIONAL_EMAIL_MOBILE: 5,
        FREELANCER: 6
    },
    PROFESSIONAL_EMAIL_LOGIN_PAGE_IDENTIFIER: {
        LOADING: "loading",
        LANDING_PAGE: "landingpage",
        PROFESSIONAL_LOGIN_FLOW: "professionalloginflow",
        PROFESSIONAL_LOGIN_FLOW_FOR_MOBILE: "professionalloginflowformobile",
        PROFESSIONAL_DUPLICATE_USER: "professionalduplicateuser",
        RECRUITER_LOGIN_FLOW: "recruiterloginflow",
        PROFESSIONAL_EMAIL_LANDING_PAGE: "reclandingpage",
        REC_LOGIN_PAGE: "r0102",
        REC_SUCCESS: "r0103",
        REC_RESET_PSWD_PAGE: "r0104"
    },

    LOGIN_PAGE_IDENTIFIER: {
        LOADING: "loading",
        LANDING_PAGE: "landingpage",
        PROFESSIONAL_LOGIN_FLOW: "professionalloginflow",
        PROFESSIONAL_LOGIN_FLOW_FOR_MOBILE: "professionalloginflowformobile",
        PROFESSIONAL_EMAIL_LOGIN_FLOW_FOR_DESKTOP: "professionalemailloginflowfordesktop",
        PROFESSIONAL_EMAIL_LOGIN_FLOW_FOR_MOBILE: "professionalemailloginflowformobile",
        RECRUITER_LOGIN_FLOW: "recruiterloginflow",
        REC_LANDING_PAGE: "reclandingpage",
        PROF_LANDING_PAGE: "professionallandingpage",
        REC_LOGIN_PAGE: "r0102",
        PROF_LOGIN_PAGE: "professionalloginpage",
        REC_SUCCESS: "r0103",
        REC_RESET_PSWD_PAGE: "r0104",
        PROFESSIONAL_RESET_PSWD_PAGE: "professionalresetpasswordpage",
        PROFESSIONAL_SUCCESS: "professionalpassword",
        //------------------Freelancer---------------------------------------------
        //FREELANCER_LOGIN_FLOW: "freelancerloginflow",
        FREELANCER_LOGIN_PAGE: 'freelancer_login_page',
        FREELANCER_LANDING_PAGE: "freelancer_landing_page",
        FREELANCER_SIGNUP_SUCCESS: "freelancer_success",
        FREELANCER_RESET_PSWD_PAGE: "freelancer_reset_pswd_page",
        FREELANCER_LOGIN_FLOW: "freelancer_login_flow",
        FREELANCER_SUCCESS: "freelancer_success"
    },

    KEY_CODE: {
        ENTER: 13,
        ARROW_UP: 30,
        ARROW_DOWN: 40,
        ESC: 27,
        PERIOD: 46
    },

    REGEX: {
        // EMAIL: /^[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?/,
        EMAIL: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
        PASSWORD: /^(?=.*[A-Za-z])[a-zA-Z!@#$%&*\d]{6,127}$/,
        PSWD_ANY: /^.{6,127}/
    },

    ACTIONS: {
        VERIFY_REC_EMAIL: "action_verify_recruiter_email",
        VERIFY_PROF_EMAIL: "action_verify_professional_email",
        SIGN_UP_REC: "action_signup_recruiter",
        SIGN_UP_PROFESSIONAL: "action_signup_professional",
        LOGIN: "action_login",
        RESET_PSWD: "action_forgot_password_recruiter",
        RESET_PSWD_PROFESSIONAL: "action_forgot_password_professional",
        ACTION_LOGIN_USING_GOOGLE: "action_login_using_google",
        //-------------Freelancer----------------------------------
        VERIFY_FREELANCER_EMAIL: "action_verify_freelancer_email",
        SIGN_UP_FREELANCER: "action_signup_freelancer",
        RESET_PSWD_FREELANCER: "action_forgot_password_freelancer"


    },

    MIN_PSWD: 6,
    REQ_TIMEOUT: 15 * 60 * 1000,
    REDIRECT_AFTER_LOGIN: {
        PROFESSIONALS: {
            MOBILE: {
                JOB_LISTING: "joblisting"
            }
        }
    },
    TALENTPARTNER_EMAIL_REGEX: /@talentxo\.co$/,
};

export default ConstantsLg;


// WEBPACK FOOTER //
// ./src/ConstantsLg.js